"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconHistory = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M61.23 46.74a29.62 29.62 0 0 0-38.31-39 34.77 34.77 0 0 0-8.16 4.46l-1.45 1.09.93-6.48a1.37 1.37 0 1 0-2.72-.39l-1.57 11a1.57 1.57 0 0 0 0 .27v.28L10 18l.05.11.08.13.1.13.11.11.16.13.13.08.14.06.2.06h10.52a1.37 1.37 0 1 0 0-2.75h-7.37l1.67-1.34a31.74 31.74 0 0 1 8.12-4.56A26.87 26.87 0 0 1 44 60.1 26.9 26.9 0 0 1 9 45.28a1.38 1.38 0 0 0-1.28-.86 1.38 1.38 0 0 0-1.22 1.89 29.61 29.61 0 0 0 54.73.43z"
  }), _react["default"].createElement("path", {
    d: "M33.38 35.07l.14-12.43a1.38 1.38 0 0 0-1.36-1.39 1.38 1.38 0 0 0-1.38 1.36l-.15 13.21V36a1.21 1.21 0 0 0 .08.42v.15a1.43 1.43 0 0 0 .24.34l.08.07a1.51 1.51 0 0 0 .33.23l.15.09 17.2 7.28a1.37 1.37 0 0 0 1.8-.73 1.38 1.38 0 0 0-.73-1.8z"
  }), _react["default"].createElement("path", {
    d: "M30.73 38.54",
    fill: "none"
  })),
  height: undefined,
  width: undefined
});
IconHistory.displayName = 'IconHistory';
var _default = IconHistory;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/history.js
// module id = 226
// module chunks = 0